import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import { Button, Card, OverlayTrigger, Tooltip } from 'react-bootstrap';

export default function PaginationDomainsSkeleton() {
  return (
    <Card.Footer className={classNames('d-flex justify-content-center')}>
      <div>
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip style={{ position: 'fixed' }}>قبلی</Tooltip>}
        >
          <Button
            disabled
            variant="falcon-default"
            size="sm"
            className="me-2 text-400"
          >
            <FontAwesomeIcon icon="chevron-right" />
          </Button>
        </OverlayTrigger>
      </div>

      <ul className="pagination mb-0">
        {Array.from({ length: 5 }, (_, index) => index + 1).map(page => (
          <li key={page}>
            <Button
              size="sm"
              disabled
              variant="falcon-default"
              className="page me-2 text-400"
            >
              {'...'.toPersianDigit()}
            </Button>
          </li>
        ))}
      </ul>
      <div>
        <OverlayTrigger
          trigger="click"
          placement="top"
          overlay={
            <Tooltip style={{ position: 'fixed' }} id="button-tooltip-2">
              بعدی
            </Tooltip>
          }
        >
          <Button variant="falcon-default" disabled size="sm" className="text-400">
            <FontAwesomeIcon icon="chevron-left" />
          </Button>
        </OverlayTrigger>
      </div>
    </Card.Footer>
  );
}
